<template>
  <q-layout class="layout" view="lHh Lpr lff">
    <jt-messagebox />
    <q-header>
      <q-toolbar
        :class="['bg-header shadow-2', bgEnvironment]"
        size="45px"
      >
        <div v-if="isNotProdEnvironment" class="environment-indicator" >
          {{ environmentMessage }}
        </div>

        <q-btn
          class="btn-header"
          flat
          round
          dense
          size="1rem"
          icon="menu"
          name="menuItem"
          @click="toggleLeft = !toggleLeft"
          aria-label="Toggle menu on left side"
        />
        <q-toolbar-title class="row self-center align-center">
          <div class="logo-icon">
            <img class="system-logo" src="../../assets/logoWaste.png" />
          </div>
          <div
            class="col-lg-4 col-md-5 col-sm-6 thin-text line-vertical q-mt-xs ellipsis"
          >
            <translate>WASTE</translate>
          </div>
        </q-toolbar-title>
        <VersionDisplay/>
        <div>
          <q-btn
            id="MainLayoutBtOrganizationalStructure"
            flat
            size="0.8rem"
            icon="business"
            aria-label="Toggle user on right side"
            class="btn-header"
            :label="
              organizationalStructureController.activeOrganizationalStructure
                ? organizationalStructureController
                    .activeOrganizationalStructure.name
                : ''
            "
          >
            <q-menu
              fit
              :persistent="true"
              anchor="bottom middle"
              self="top middle"
            >
              <q-list class="padding-10">
                <div class="text-subtitle1 text-info">
                  <translate>ORGANIZATIONAL_STRUCTURE</translate>
                </div>
                <q-item clickable>
                  <q-item-section>
                    <organizational-structure-menu />
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
          <q-btn
            v-if="isDevEnvironment"
            id="MainLayoutBtConfiguration"
            flat
            @click="layoutController.reloadConfigurations()"
            size="0.8rem"
            icon="cached"
            :label="$gettext('CONFIGURATIONS')"
            aria-label="Toggle user on right side"
            class="btn-header"
          />
          <q-btn
            id="MainLayoutBtSelectedLanguage"
            flat
            size="0.8rem"
            aria-label="Toggle user on right side"
            class="btn-header"
          >
            <q-avatar size="1.5em" class="flag">
              <img class="flag-icon" src="../../assets/brazil.png" />
            </q-avatar>
            <span class="text-flag">PT-BR</span>
            <q-menu
              fit
              anchor="bottom middle"
              self="top middle"
              max-width="350px"
              auto-close
            >
              <q-list style="min-width: 105px">
                <q-item clickable>
                  <q-item-section>
                    <q-avatar size="1.5em" class="flag-options">
                      <img class="flag-icon" src="../../assets/USA.png" />
                    </q-avatar>
                  </q-item-section>
                  <q-item-section>
                    <span class="text-flag-inside">EN-US</span>
                  </q-item-section>
                </q-item>
                <q-separator />
                <q-item clickable>
                  <q-item-section>
                    <q-avatar size="1.5em" class="flag-options">
                      <img class="flag-icon" src="../../assets/Spain.png" />
                    </q-avatar>
                  </q-item-section>
                  <q-item-section>
                    <span class="text-flag-inside">ES</span>
                  </q-item-section>
                </q-item>
                <q-separator />
                <q-item clickable>
                  <q-item-section>
                    <q-avatar size="1.5em" class="flag-options">
                      <img class="flag-icon" src="../../assets/France.png" />
                    </q-avatar>
                  </q-item-section>
                  <q-item-section>
                    <span class="text-flag-inside">FR</span>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
          <notification />
          <q-btn id="MainLayoutBtAvatarUser" round class="avatar" size="12px">
            <q-avatar size="40px">
              <img
                v-if="
                  globalController.profile && globalController.profile.photoURL
                "
                :src="globalController.profile.photoURL"
              />
              <img v-else src="~assets/avatar.jpg" />
            </q-avatar>
            <q-menu
              fit
              anchor="bottom left"
              self="top middle"
              max-width="280px"
              auto-close
            >
              <q-list class="padding-10" style="min-width: 100px">
                <div class="text-subtitle1 text-info">
                  <translate>HELLO</translate>,
                  <b v-if="globalController.profile">{{
                    globalController.profile.name ||
                    globalController.profile.displayName
                  }}</b>
                </div>
                <q-item>
                  <q-item-section>
                    <div class="q-gutter-sm">
                      <q-btn
                        id="btnExitSystem"
                        flat
                        size="1.1rem"
                        icon="exit_to_app"
                        class="text-primary"
                        aria-label="Toggle user on right side"
                        :label="$gettext('LEAVE')"
                        @click="logoutClickHandler"
                      >
                        <q-tooltip
                          anchor="bottom middle"
                          self="top middle"
                          content-style="font-size: 13px"
                          :offset="[5, 5]"
                          >{{ $gettext("LEAVE") }}</q-tooltip
                        >
                      </q-btn>
                    </div>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
        </div>
      </q-toolbar>
    </q-header>
    <q-drawer
      v-model="toggleLeft"
      :overlay="false"
      content-class="text-white"
      side="left"
    >
      <SideMenu :items="layoutController.modules" />
    </q-drawer>
    <q-page-container>
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        mode="out-in"
      >
        <router-view :key="$route.fullPath"></router-view>
      </transition>
      <q-dialog v-model="logoutConfirm" persistent>
        <q-card class="modal-smaller q-pt-md no-scroll">
          <q-card-section class="text-center q-mb-md">
            <q-avatar icon="exit_to_app" color="warning" text-color="white" />
            <div class="mt-15">
              <span class="msg-confirm">
                <translate>LOGOUT_MESSAGE</translate>
              </span>
            </div>
          </q-card-section>

          <q-card-actions align="center" class="q-px-md">
            <q-btn
              unelevated
              :label="$gettext('NO')"
              color="grey"
              class="btn-padding"
              size="md"
              v-close-popup
            />
            <q-btn
              unelevated
              id="YESLogout"
              :label="$gettext('YES')"
              color="secondary"
              class="btn-padding"
              size="md"
              @click="logoutSystem"
            />
          </q-card-actions>
        </q-card>
      </q-dialog>
    </q-page-container>
    <v-chart ref="chart" class="jtchart" :option="getChartOption()" />
  </q-layout>
</template>
<script>
import {
  QLayout,
  QHeader,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QPageContainer,
  QDrawer,
  QDialog,
  QCard,
  QCardSection
} from 'quasar'
import toolbar from '@/toolbar/Toolbar'
import { JtMessagebox } from 'jtech-webcomps'
import { Component, Vue, Watch } from 'vue-property-decorator'
import SideMenu from './Sidemenu'
import LockupModal from '@/lockup'
import { Observer } from 'mobx-vue'
import { LayoutController } from './LayoutController'
import { LoginController } from '../login/LoginController'
import { OrganizationalStructureController } from '../organizational-structure/OrganizationalStructureController'
import OrganizationalStructureMenu from 'src/modules/organizational-structure/OrganizationalStructureMenu'
import { jtChartMethods } from 'src/components/charts/shared'
import { GlobalController } from 'src/shared/global/GlobalController'
import Notification from 'src/modules/notification/Notification.vue'
import { version } from '../../../package.json'
import { Environment } from 'src/shared/global/EnvironmentEnum'
import VersionDisplay from 'src/components/versionDisplay/versionDisplay.vue'

@Observer
@Component({
  name: 'mainLayout',
  components: {
    toolbar,
    LockupModal,
    JtMessagebox,
    QLayout,
    QHeader,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QPageContainer,
    QDrawer,
    SideMenu,
    QDialog,
    QCard,
    QCardSection,
    OrganizationalStructureMenu,
    Notification,
    VersionDisplay
  }
})
export default class MainLayout extends Vue {
  logoutConfirm = false;
  toggleLeft = false;
  OrganizationalStr;
  layoutController = LayoutController.getInstance();
  loginController = LoginController.getInstance();
  globalController = GlobalController.getInstance();
  organizationalStructureController =
    OrganizationalStructureController.getInstance();

  userProfile = {};

  async mounted () {
    this.layoutController.fetchModules()
    await this.organizationalStructureController.loadOrganizationalStructureComponent()
    if (this.$refs.chart.chart._model.option.color) {
      this.layoutController.setChartColor(
        this.$refs.chart.chart._model.option.color
      )
    }
  }

  get version () {
    return version
  }

  get isDevEnvironment () {
    return process.env.VUE_APP_ENVIRONMENT === Environment.DEVELOPMENT
  }

  get isNotProdEnvironment () {
    return process.env.VUE_APP_ENVIRONMENT !== Environment.PRODUCTION
  }

  get bgEnvironment () {
    return `bg-${process.env.VUE_APP_ENVIRONMENT}`
  }

  logoutSystem () {
    this.loginController.logout()
  }

  lockClickHandler () {
    this.$refs.lockModal.show()
  }

  logoutClickHandler () {
    this.logoutConfirm = true
  }

  clickEditProfile () {
    alert('Edited')
  }

  getChartOption () {
    return jtChartMethods.getChartOption()
  }

  get computedUserAvatar () {
    return this.globalController.profile.source === 'google'
      ? Object.values(this.globalController.profile).find((el) =>
        String(el).startsWith('http')
      )
      : undefined
  }

  @Watch('$route.path')
  onRouteChange () {
    this.toggleLeft = false
  }

  get environmentMessage () {
    switch (process.env.VUE_APP_ENVIRONMENT) {
      case Environment.DEVELOPMENT:
        return this.$gettext('DEVELOPMENT_ENV_MSG')
      case Environment.TEST:
        return this.$gettext('TESTING_ENV_MSG')
      case Environment.UAT:
        return this.$gettext('UAT_ENV_MSG')
      default:
        return this.$gettext('UNKNOWN_ENV_ERROR')
    }
  }
}
</script>

<style scoped>
.msg-confirm {
  font-size: 1.5em;
  font-weight: 600;
}

.btn-padding {
  padding: 0px 50px !important;
}

.interno-fade-enter-active,
.interno-fade-leave-active {
  transition: opacity 0.5s ease;
}

.interno-fade-enter,
.interno-fade-leave-to {
  opacity: 0;
}

.thin-text {
  font-weight: 300;
  font-size: 0.9rem;
  color: #394053;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.bg-header {
  padding: 8px 20px 8px 10px;
  transition: background-color 0.3s ease;
}

.bg-development {
  background: #A5E7F0;
}

.bg-testing {
  background: #e3f0ad;
}

.bg-uat {
  background: #a5f0be;
}

.bg-production {
  background: #cad5db;
}

.environment-indicator {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 600;
  font-size: 0.9rem;
}

.q-toolbar > *:first-child {
  margin-left: 0;
}

.q-toolbar-title {
  padding-left: 12px;
}

.thin-text {
  font-weight: 300;
  font-size: 0.9rem;
  color: #394053;
}

.line-vertical {
  border-left: 1px;
  border-color: rgba(255, 255, 255, 0.4);
  border-style: solid;
  padding-left: 10px;
  height: 20%;
  border-right: none;
  border-bottom: none;
  border-top: none;
  margin-top: 5px;
}

.avatar {
  position: relative;
  margin-left: 20px;
}

.text-subtitle1 {
  padding: 3px 8px;
}

.q-item {
  padding: 8px;
}

.mg-icons-menu {
  margin-top: -5px;
  padding-bottom: 15px;
}

.btn-header {
  color: #6f8896;
}

.logo-icon {
  text-align: center;
}

.system-logo {
  margin: -5px 0px -12px -11px;
  width: 75%;
}

.layout {
  background-color: #f2f4f5;
}

.flag {
  margin-right: 5px;
}

.text-flag {
  font-size: 0.9rem;
}

.text-flag-inside {
  font-size: 0.9rem;
  margin-left: -12px;
}

.flag-options {
  margin-left: 5px;
  margin-right: -50px;
}

.text-sub {
  font-size: 0.8rem;
}

.text-normal {
  font-size: 1.1rem;
}

.jtchart {
  height: 0px;
  width: 0px;
}

.environment-indicator {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
  margin-right: 10px;
  font-size: 0.8rem;
  font-weight: bold;
}
</style>
